import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, FormControl, Grid, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Box } from "@mui/system";
import ErrorBoundary from "../../../../common/ErrorBoundary";
import { TableSkeleton } from "../../../../common/Skeletons";
import usePickupPerformance from "./usePickupPerformance";
import OverallAgeing from "./OverallAgeing";
import CourierWiseSplit from "./CourierWiseSplit";
import PincodeWiseSplit from "./PincodeWiseSplit";
import CityWiseSplit from "./CityWiseSplit";
import PickupAdherence from "./PickupAdherence";
import ReasonAnalysis from "./ReasonAnalysis";
import { useSelector } from "react-redux";

function PickupComponent() {

    const [calcOn, setCalcOn] = React.useState('DOD')
    const [shipType, setShipType] = useState("B2C")
    const { isLoading, data } = usePickupPerformance(calcOn, shipType)
    const handleChange = (event) => {
        setShipType(event.target.value);
    }
    const { userInfo } = useSelector((state) => state.user)
    return (
        <Accordion expanded>
            <AccordionSummary sx={{ boxShadow: 1, borderRadius: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 600 }}>Pickup Performance</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {(userInfo?.merchant?.isD2CMerchant && userInfo?.merchant?.isPTLMerchant) &&
                                <FormControl variant="outlined" size="small" sx={{ minWidth: 100 }}>
                                    <InputLabel sx={{ fontSize: '0.7rem' }}>Shipment Type</InputLabel>
                                    <Select
                                        value={shipType}
                                        onChange={handleChange}
                                        label="Shipment Type"
                                        sx={{
                                            fontSize: '0.75rem',
                                            height: 30,
                                            '& .MuiSelect-select': { py: 0.5 },
                                        }}
                                    >
                                        <MenuItem value={"B2C"} sx={{ fontSize: '0.75rem' }}>B2C</MenuItem>
                                        <MenuItem value={"B2B"} sx={{ fontSize: '0.75rem' }}>B2B</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                            <ToggleButtonGroup
                                color="primary"
                                value={calcOn}
                                exclusive
                                size="small"
                                onChange={(_e, v) => setCalcOn(v)}
                                sx={{
                                    '& .MuiToggleButton-root': {
                                        border: '1px solid',
                                    }
                                }}
                            >
                                <ToggleButton value="DOD">DoD</ToggleButton>
                                <ToggleButton value="WOW">WoW</ToggleButton>
                                <ToggleButton value="MOM">MoM</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary', mt: 0.5 }}>
                        The data below provides analysis on the pickup performance. All data is populated on basis of the date of shipment creation in Proship and the corresponding pickup date.
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#f5f8fa', px: 0 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        {isLoading && <TableSkeleton rows={10} />}
                        {!isLoading && (
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <OverallAgeing data={data} />
                                </Grid>
                                <Grid item xs={12}>
                                    <CourierWiseSplit data={data} />
                                </Grid>
                                <Grid item xs={12}>
                                    <PincodeWiseSplit data={data} />
                                </Grid>
                                <Grid item xs={12}>
                                    <PickupAdherence
                                        data={data?.sameDayPickupAdherence || []}
                                        title="Courier Wise Pickup Adherence"
                                        subHeader="Same-day vs next-day pickup split by courier"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CityWiseSplit data={data} />
                                </Grid>
                                <Grid item xs={12}>
                                    <ReasonAnalysis data={data?.pickupFailureReasons || []} />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default function PickupPerformance() {
    return (
        <ErrorBoundary>
            <PickupComponent />
        </ErrorBoundary>
    )
}